import { restClient } from '../client';
import { Asset } from '../resources';


export const getAssetsByIds = async (assetIds: string[]) => restClient.rawRequest<{ data: Record<string, Asset> }>('/api/v1/get_public_assets', {
  method: 'POST',
  data: {
    asset_ids: assetIds,
  },
});


export enum UploadPurpose {
  patientDocument = 'patient_document',
}

export enum FileResourceType {
  public = 'public',
  protected = 'protected',
}

export enum AssetReference {
  insurance = 'insurance',
  nonPartnerInsurance = 'non_partner_insurance',
}

export type AssetUploadType = {
  file_content: string;
  file_name: string;
  resource_type: FileResourceType;
  resource_name: string;
};

export type AssetUploadResponse = {
  id: string;
  url: string;
  resource_type: string;
} | {
  error: string;
};

export type AssetUploadRequest = {
  url: string;
  method: 'POST';
};

export type FileUpload = {
  id: string;
  key: string;
  name: string;
  created_at: string;
  patient_id: string;
  purpose: UploadPurpose;
  user_id: string;
};


const documentUploadRequest = async (data: {
  file_name: string;
  patient_id: string;
  purpose: UploadPurpose;
}) => restClient.rawRequest<{
  data: {
    url: string;
    file_name: string;
    fields: Record<string, string>;
    file_upload: FileUpload;
  };
}>('/api/v1/assets/upload_request', {
  method: 'POST',
  data: data,
});


const uploadFileToS3WithCredentials = async (url: string, fields: Record<string, string>, file: File) => {
  const formData = new FormData();

  Object.keys(fields).forEach(key => {
    formData.append(key, fields[key]);
  });

  formData.append('file', file);

  const response = await fetch(url, {
    method: 'POST',
    body: formData,
    mode: 'no-cors',
  });

  return response.body;
};


export const uploadFileToS3 = async (patientId: string, purpose: UploadPurpose, file: File) => {
  const uploadReq = await documentUploadRequest({
    file_name: file.name,
    patient_id: patientId,
    purpose: purpose,
  });

  await uploadFileToS3WithCredentials(uploadReq.data.url, uploadReq.data.fields, file);

  return uploadReq.data;
};

export const assetUpload = restClient.createRequest<AssetUploadType, AssetUploadResponse>({
  url: '/assets/upload',
  method: 'POST',
});


export const getProtectedAssetUrl = async (assetId: string, reference: AssetReference) => {
  const response = await restClient.request<{ data: { url: string } }>('/assets/protected', {
    method: 'POST',
    data: {
      asset_id: assetId,
      reference: reference,
    }
  });

  return response?.data?.url;
};
